import React from "react";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  ListItemText,
} from "@mui/material";

const FONT = "'Host Grotesk', sans-serif";

const statuses = [
  { value: null, label: "All",              color: "#6366f1", dot: "#6366f1" },
  { value: -3,   label: "Crawling Failed",  color: "#dc2626", dot: "#dc2626" },
  { value: -2,   label: "No Data Found",    color: "#f59e0b", dot: "#f59e0b" },
  { value: 0,    label: "Extracting Data",  color: "#3b82f6", dot: "#3b82f6" },
  { value: 1,    label: "Crawling Complete",color: "#10b981", dot: "#10b981" },
  { value: 2,    label: "Queued",           color: "#ef4444", dot: "#ef4444" },
  { value: 3,    label: "Running Analysis", color: "#f97316", dot: "#f97316" },
  { value: 4,    label: "Analysis Complete",color: "#8b5cf6", dot: "#8b5cf6" },
];

const StatusDropdown = ({ selectedStatus, handleStatusClick }) => {
  const selected = statuses.find(
    (s) => s.value === (selectedStatus ?? null)
  ) ?? statuses[0];

  return (
    <FormControl sx={{ width: "100%" }} size="small">
      <InputLabel
        id="status-dropdown-label"
        shrink
        sx={{
          fontFamily: FONT,
          fontSize: "13px",
          color: "#94a3b8",
          "&.Mui-focused": { color: "#6366f1" },
        }}
      >
        Status
      </InputLabel>
      <Select
        labelId="status-dropdown-label"
        value={selectedStatus ?? ""}
        onChange={(e) => {
          const value = e.target.value === "" ? null : Number(e.target.value);
          handleStatusClick(value);
        }}
        displayEmpty
        label="Status"
        renderValue={() => (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{
              width: 7, height: 7,
              borderRadius: "50%",
              backgroundColor: selected.dot,
              flexShrink: 0,
              display: "inline-block",
            }} />
            <span style={{ fontFamily: FONT, fontSize: "13px", color: "#1e293b" }}>
              {selected.label}
            </span>
          </div>
        )}
        sx={{
          height: "44px",
          borderRadius: "10px",
          fontFamily: FONT,
          fontSize: "13px",
          backgroundColor: "#ffffff",
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#a5b4fc",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#6366f1",
            borderWidth: "1.5px",
          },
        }}
        MenuProps={{
          PaperProps: {
            style: {
              borderRadius: "12px",
              boxShadow: "0 8px 30px rgba(0,0,0,0.10)",
              border: "1px solid #e2e8f0",
              marginTop: "4px",
              fontFamily: FONT,
            },
          },
        }}
      >
        {statuses.map(({ value, label, color, dot }) => {
          const isSelected = (selectedStatus ?? null) === value;
          return (
            <MenuItem
              key={label}
              value={value ?? ""}
              sx={{
                fontFamily: FONT,
                fontSize: "13px",
                fontWeight: isSelected ? 600 : 400,
                borderRadius: "8px",
                mx: "4px",
                my: "2px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                color: isSelected ? color : "#374151",
                backgroundColor: isSelected ? `${color}12` : "transparent",
                "&:hover": {
                  backgroundColor: `${color}18`,
                  color: color,
                },
              }}
            >
              <span style={{
                width: 7, height: 7,
                borderRadius: "50%",
                backgroundColor: dot,
                flexShrink: 0,
                display: "inline-block",
                marginRight: 2,
              }} />
              <ListItemText
                primary={label}
                primaryTypographyProps={{
                  fontFamily: FONT,
                  fontSize: "13px",
                  fontWeight: isSelected ? 600 : 400,
                }}
              />
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default StatusDropdown;